import { DisplayError } from "@/components/Error/Error";
import { Loading } from "@/components/Loading/Loading";
import { useAuth0 } from "@auth0/auth0-react";
import { FC, ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface VerifiedEmailGuardProps {
  redirectRoute?: string;
  children: ReactNode;
}

export const VerifiedEmailGuard: FC<VerifiedEmailGuardProps> = ({ redirectRoute = "/cases", children }) => {
  const navigate = useNavigate();
  const { user, isLoading, error } = useAuth0();

  useEffect(() => {
    if (!user?.email_verified) {
      navigate(`/verify-email?target=${encodeURIComponent(redirectRoute)}`, {
        replace: true
      });
    }
  }, [user?.email_verified, navigate, redirectRoute]);

  if (isLoading) {
    return <Loading />;
  }

  if (!user?.email_verified) {
    return <Loading />;
  }

  if (error) {
    return <DisplayError error={error} />;
  }

  return children;
};
